// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-templates-notes-jsx": () => import("./../../../src/templates/Notes.jsx" /* webpackChunkName: "component---src-templates-notes-jsx" */)
}

